import { queryConfig } from './queryConfig';

export interface Merchant {
  uid: string;
  name: string;
  email: string;
  phone: string;
  status: string;
  remarks: string | null;
  created_at: string;
}

const query = queryConfig({});

export const useGetMerchants = (params?: { page?: number; limit?: number; q?: string }) =>
  query<{ page: number; limit: number; total: number; merchants: Merchant[] }>({
    url: '/v1/ops/merchants',
    cacheKey: 'merchants',
    params,
  });
